import { render } from "./Renew.vue?vue&type=template&id=37cd87e8&scoped=true"
import script from "./Renew.vue?vue&type=script&lang=js"
export * from "./Renew.vue?vue&type=script&lang=js"

import "./Renew.vue?vue&type=style&index=0&id=37cd87e8&lang=scss&scoped=true"
import "./Renew.vue?vue&type=style&index=1&id=37cd87e8&lang=css"
script.render = render
script.__scopeId = "data-v-37cd87e8"

export default script